/** Field names for the forgot-password form. */
export const FORGOT_PASSWORD_FIELDS = {
  EMAIL: 'email'
} as const;

/** Sentry feature tag for the forgot-password flow. */
export const FORGOT_PASSWORD_FEATURE_TAG = 'forgot-password' as const;

/** Rendering variants for the forgot-password card (initial form, expired-code entry). */
export const FORGOT_PASSWORD_VARIANT = {
  DEFAULT: 'default',
  EXPIRED_CODE: 'expiredCode'
} as const;

/** Account restriction error codes returned as 403 Forbidden by the forgot-password API. */
export const FORBIDDEN_ERROR_CODE = {
  DEMO_ACCOUNT: 'DEMO_ACCOUNT'
} as const;

/** Server validation error codes returned by the forgot-password API. */
export const VALIDATION_ERROR_CODE = {
  ERROR_REQUIRED: 'ERROR_REQUIRED',
  ERROR_INVALID_EMAIL: 'ERROR_INVALID_EMAIL',
  ERROR_INVALID_LENGTH: 'ERROR_INVALID_LENGTH',
  ERROR_CAPTCHA_FAILED: 'ERROR_CAPTCHA_FAILED'
} as const;

/** Tracking configuration for the forgot-password form */
export const FORGOT_PASSWORD_FORM_TRACKING_CONFIG = {
  eventPrefix: 'forgot_password',
  eventCategory: 'forgot_password',
  eventLabel: 'email'
} as const;
